<h2 mat-dialog-title>
  <!-- <h3>Financial Assessment — {{selectedCoreName}}</h3> -->
  <h3 class="title-text">Financial Assessment -&nbsp; </h3> <b style="color: #2e5bff;"> {{ selectedCoreName }}</b>
  <button mat-icon-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>

</h2>

<mat-dialog-content>
  <div class="popup-container">

    <div class="popup-body">
      <div class="tab-section">
          <button class="tab"  [ngClass]="{ 'active': selectedtypeforActive === 0 }" 
           (click)="selectType(0)">Combined
          </button>

          <button class="tab" [ngClass]="{ 'active': selectedtypeforActive === 1 }" 
            (click)="selectType(1)">Resident
          </button>

          <button class="tab" 
             [ngClass]="{ 'active': selectedtypeforActive === 2 }" 
             (click)="selectType(2)">Spouse
          </button>

        <!-- <button class="tab active" (click)="selectType(0)">Combined</button>
        <button class="tab" (click)="selectType(0)">Resident</button>
        <button class="tab" (click)="selectType(1)">Spouse</button> -->
      </div>

      <div class="popup-content">
        <!-- Left column -->
        <div class="left-column">
          <div class="section-header">
            <h4>Income</h4>
            <button class="add-btn" (click)="addIncome()">+ Add Income</button>
          </div>

       
          <div class="item" *ngFor="let income of incomesList">

            <div class="item-left" >
              <div class="item-title">{{income.title}}</div>
              <div class="item-amount">${{income.amount}}</div>
              <div class="item-note">
                  {{ income.frequency == 1 ? 'Monthly' : income.frequency == 2 ? 'Yearly' : '' }}
                  •
                  {{
                    income.verificationStatus == 1
                      ? 'Pending Verification'
                      : income.verificationStatus == 2
                        ? 'Verified'
                        : ''
                  }}
                  •
                  {{
                    income.incomeBy == 0
                      ? 'Resident'
                      : income.incomeBy == 1
                        ? 'Spouse'
                        : ''
                  }}
              </div>

            </div>

            <div class="item-actions">
              <button matTooltip="Edit" mat-icon-button class="edit-btn" aria-label="Edit" (click)="editIncome(income)">
                <mat-icon>edit</mat-icon>
              </button>

              <button matTooltip="Delete" mat-icon-button class="delete-btn" aria-label="Delete" (click)="deleteIncome(income)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>

          </div>


          <!-- <div class="item">
          <div class="item-title">VA Pension</div>
          <div class="item-amount">$1,390</div>
          <div class="item-note">Monthly • Pending Verification</div>
        </div> -->

          <div class="section-header">
            <h4>Assets</h4>
            <button class="add-btn" (click)="addAsset('Asset')">+ Add Asset</button>
          </div>

           <div class="item" *ngFor="let asset of assetsList">

            <div class="item-left" >
              <div class="item-title">{{asset.title}}</div>
              <div class="item-amount">${{asset.amount}}</div>
             <div class="item-note">
                  {{ asset.classification == 1 ? 'Countable' : asset.classification == 0 ? 'Excluded' : '' }}
                  •
                  {{
                    asset.assetBy == 0
                      ? 'Resident'
                      : asset.assetBy == 1
                        ? 'Spouse'
                        : ''
                  }}
                </div>

            </div>

            <div class="item-actions">
              <button matTooltip="Edit" mat-icon-button class="edit-btn" aria-label="Edit" (click)="editAsset('Asset',asset)">
                <mat-icon>edit</mat-icon>
              </button>

              <button matTooltip="Delete" mat-icon-button class="delete-btn" aria-label="Delete" (click)="deleteAsset(asset)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>

           </div>

          <!-- <div class="item">
            <div class="item-title">Checking Account</div>
            <div class="item-amount">$1,750</div>
            <div class="item-note">Bank of America • Countable</div>
          </div>

          <div class="item">
            <div class="item-title">Primary Residence</div>
            <div class="item-amount">$12,000</div>
            <div class="item-note">Owner: 100%</div>
          </div> -->

          <!-- ✅ Added Allowable Expenses Section -->
          <div class="section-header">
            <h4>Allowable Expenses</h4>
            <button class="add-btn" (click)="addAsset('Expense')">+ Add Expense</button>
          </div>

          <div class="item" *ngFor="let expenses of expensesList">

            <div class="item-left" >
              <div class="item-title">{{expenses.title}}</div>
              <div class="item-amount">${{expenses.amount}}</div>
              <div class="item-note">
                {{ expenses.classification == 1 ? 'Countable' : expenses.classification == 0 ? 'Excluded' : '' }}
                •
                {{
                  expenses.expenseBy == 0
                    ? 'Resident'
                    : expenses.expenseBy == 1
                      ? 'Spouse'
                      : ''
                }}
              </div>

            </div>

            <div class="item-actions">
              <button matTooltip="Edit" mat-icon-button class="edit-btn" aria-label="Edit" (click)="editAsset('Expense',expenses)">
                <mat-icon>edit</mat-icon>
              </button>

              <button matTooltip="Delete" mat-icon-button class="delete-btn" aria-label="Delete" (click)="deleteExpense(expenses)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>

           </div>

          <!-- <div class="item">
            <div class="item-title">Medicare Part B Premium</div>
            <div class="item-amount">$164.90</div>
          </div>

          <div class="item">
            <div class="item-title">Personal Needs Allowance</div>
            <div class="item-amount">$75.00</div>
          </div>

          <div class="item">
            <div class="item-title">Spouse Allowance</div>
            <div class="item-amount">$400.00</div>
          </div> -->

        </div>


        <!-- Right column -->
        <div class="right-column">
          <!-- <div class="eligibility-chip">✅ Eligible for Medicaid</div> -->

          <div class="summary-card">
            <div class="section">
              <h4>Income & Liability</h4>
              <div class="data-row">
                <span class="label">Gross Income</span>
                <span class="value">${{grossIncome | number:'1.2-2'}}</span>
              </div>
              <div class="data-row negative">
                <span class="label">Allowable Deductions</span>
                <span class="value">${{allowableDeduction | number:'1.2-2'}}</span>
              </div>
              <div class="data-row positive highlight">
                <span class="label">Net Income</span>
                <span class="value">${{netIncome | number:'1.2-2'}}</span>
              </div>
              <div class="data-row positive highlight">
                <span class="label">Personal Needs Allowance</span>
                 <span class="value custom-input">
                 <input matInput placeholder="add amount"
                   (keypress)="numberOnly($event)"
                   [(ngModel)]="pnAllowance">
                 </span>

              </div>

              <div class="data-row">
              <span class="label">Est. Patient Liability</span>
              <span class="value">${{estPatientLiability | number:'1.2-2'}}</span>
            </div>
            </div>

            <div class="section">
              <h4>Assets</h4>
              <div class="data-row">
                <span class="label">Countable Assets</span>
                <span class="value">${{countableAsset | number:'1.2-2'}}</span>
              </div>
              <div class="data-row">
                <span class="label">Exempt Assets</span>
                <span class="value">${{exemptAsset | number:'1.2-2'}}</span>
              </div>
              <div class="data-row">
              <span class="label">Resource Limit</span>
               <span class="value custom-input">
                <input matInput placeholder="add amount"
                  (keypress)="numberOnly($event)"
                  [(ngModel)]="resourceLimit">
                 </span>
              <!-- <span class="value"><input matInput placeholder="Enter amount" (keypress)="numberOnly($event)"
                 [(ngModel)]="resourceLimit"></span> -->
             
            </div>
            <div class="data-row highlight">
              <span class="label">Spenddown Needed</span>
              <span class="value">${{spenddownNeeded | number:'1.2-2'}}</span>
            </div>
            </div>

            <!-- <div class="section">
            <h4>Flags</h4>
            <div class="flag verified">MMIS Verified</div>
            <div class="flag pending">Bank Stmts Pending</div>
          </div> -->

            <div class="button-group">
              <button class="save-btn" (click)="addPNAadResourceLimit()">Save & Recalculate</button>
              <!-- <button class="export-btn">Export Summary PDF ▼</button> -->
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>



</mat-dialog-content>